export const OptionsSelector = ({ data, handleOptionSelect, selectedValue, label }) => {
    return (
        <div className="options-selector-container">
            <label htmlFor="options-selector" className="m-0 text-nowrap">{ label }</label>
            <select
                id="options-selector"
                className="border rounded py-1 px-2"
                onChange={ (e) => handleOptionSelect(e.target.value) }
                value={ selectedValue }
            >
                { data && Object.entries(data).map(([key, value]) =><option key={ key } value={ key }>{ value }</option>) }
            </select>
        </div>
    )
}